import type { ReactNode } from 'react'

import { badgeTone, type BadgeTone } from './kit'

/** A short label in a pill. For a request or day status use StatusPill, which translates the status word. */
export function Badge({ tone = 'neutral', icon, children }: { tone?: BadgeTone; icon?: ReactNode; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs ${badgeTone(tone)}`}
    >
      {icon}
      {children}
    </span>
  )
}
